import { useRef } from "react";
import FormValidation from "../../utils/FormValidation";

const PromoCodeDateField = ({
  register,
  errors,
  fieldName = "expiryDate",
  label = "Expiry Date",
}) => {
  const inputRef = useRef(null);

  const openPicker = () => {
    const input = inputRef.current;
    if (!input) return;
    if (typeof input.showPicker === "function") {
      input.showPicker();
      return;
    }
    input.focus();
    input.click();
  };

  const validation = FormValidation(fieldName, label, [{ Type: "required" }]);
  const registration = register(fieldName, validation);

  return (
    <div className="event-promo-code-field event-promo-code-date-row">
      <label className="event-promo-code-label" htmlFor={fieldName}>
        {label}*
      </label>
      <div className="event-promo-code-date-wrap">
        <input
          type="date"
          id={fieldName}
          className="event-promo-code-input event-promo-code-date"
          aria-describedby={errors[fieldName] ? `${fieldName}-error` : undefined}
          {...registration}
          ref={(element) => {
            registration.ref(element);
            inputRef.current = element;
          }}
        />
        <button
          type="button"
          className="event-promo-code-date-icon"
          aria-label={`Pick ${label.toLowerCase()}`}
          onClick={openPicker}
        >
          <i className="bi bi-calendar3" aria-hidden="true"></i>
        </button>
      </div>
      {errors[fieldName] && (
        <p className="event-promo-code-error" id={`${fieldName}-error`}>
          {errors[fieldName].message}
        </p>
      )}
    </div>
  );
};

export default PromoCodeDateField;
